<template>
  <div class="tracker_wrapper" v-if="!isLoading">
    <strategy-modal
        v-if="showColorChangeModal"
        :occurredTaskId="currentOccurredTask"
        :color="recommendedColorEntity"
        @close="showColorChangeModal = false"
        @changed="handleColorChange"
    />

    <div class="color_wrapper">
      <p>Выберите карточку и узнайте, что лучше делать в том или ином эмоциональном состоянии</p>

      <ul class="color_list">
        <li v-for="(value, key) in colorsMap" :key="key">
          <div
              class="mood_color_block"
              :class="[{ active: value === activeColor }, key]"
              @click="() => pickColor(value)"
          ></div>
        </li>
      </ul>
    </div>

    <div class="cards-container">
      <div
          v-for="(block, index) in colorBlocks"
          :key="block.id"
          class="card"
          :class="{ open: block.open }"
      >
        <div
            v-if="!block.open"
            class="card-front"
            :style="{ backgroundImage: `url(${block.image})` }"
            @click="toggleCard(index)"
        >
          <div>
            <h4><b>{{ block.title }}</b></h4>
          </div>
        </div>

        <div v-else class="card-back" :style="{ background: block.color }">
          <button class="close-btn" @click.stop="toggleCard(index)">×</button>

          <div class="card-back-header">
            <h4><b>{{ block.title }}</b></h4>

            <button
                class="card-back-status"
                @click="() => pickColor(colorsMap[block.block])"
            >
              Это мое состояние сейчас
            </button>
          </div>

          <div class="card-back-text">
            <p><b>{{ block.text?.title }}</b></p>

            <ul>
              <li v-for="(item, key) in block.text?.items" :key="key">
                {{ `&bull; ${item}` }}
              </li>
            </ul>
          </div>

          <div class="card-back-detailed">
            <button @click="openPopup(block)">
              Узнать подробнее про состояние
            </button>
          </div>
        </div>
      </div>

      <transition name="fade">
        <div v-if="selectedBlock" class="popup-overlay" @click="closePopup">
          <div
              class="popup-content"
              @click.stop
              :style="{ background: selectedBlock.color }"
          >
            <button class="popup-close" @click="closePopup">×</button>

            <h2>{{ selectedBlock.title }}</h2>

            <ul>
              <li v-for="(item, key) in selectedBlock.detailed" :key="key">
                {{ `&bull; ${item}` }}
              </li>
            </ul>

            <div class="popup_additional_wrapper">
              <p>Это похоже на то, что вы чувствуете сейчас?</p>

              <div class="popup_button_wrapper">
                <button @click="pickColor(colorsMap[selectedBlock.block])">
                  Да
                </button>

                <button @click="closePopup">
                  Нет
                </button>

                <button @click="openAssessmentTool">
                  Не знаю
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>

      <transition name="fade">
        <div class="task_wrapper" v-if="activeColor" @click="closeTaskPopup">
          <div
              class="task_content"
              @click.stop
              :style="{ borderColor: activeBlock?.color }"
          >
            <button class="popup-close" @click="closeTaskPopup">×</button>

            <div class="resume_block" v-if="activeBlock">
              <div class="additional_block_wrapper">
                <div class="colorful_block" :class="activeBlock.block"></div>
                <div class="colorful_block" :class="activeBlock.block"></div>
              </div>

              <p>
                {{ activeBlock.current }}
              </p>

              <div class="additional_block_wrapper">
                <div class="colorful_block" :class="activeBlock.block"></div>
                <div class="colorful_block" :class="activeBlock.block"></div>
              </div>
            </div>

            <div class="tasks_wrapper">
              <p class="header_green">Какую задачу вам сейчас предстоит выполнить?</p>

              <div class="select_wrapper">
                <multiselect
                    :disabled="isTaskSet"
                    :options="taskOptions"
                    v-model="moodForm.task"
                    :allow-empty="false"
                    track-by="id"
                    label="text"
                    aria-label="Выберите задачу"
                    placeholder="Выберите задачу"
                    selectedLabel="Выбрано"
                    deselectLabel=""
                    selectLabel=""
                    name="trigger_list"
                >
                  <template #noOptions>
                    Список загружается...
                  </template>
                </multiselect>
              </div>
            </div>

            <div v-if="recommendationsLoaded">
              <div
                  v-if="moodForm.task && moodForm.color_id && appropriateMood"
                  class="assessed_mood_wrapper"
              >
                <div>
                  Вы в подходящем состоянии для этой задачи. Используйте его эффективно.
                  Записать, чтобы подвести итог и зафиксировать результат?
                </div>

                <div class="button_wrapper">
                  <custom-radio
                      v-model="recordInterval"
                      id="record_task_yes"
                      label="Да"
                      name="record_task"
                      value="1"
                  />

                  <custom-radio
                      v-model="recordInterval"
                      id="record_task_no"
                      label="Нет"
                      name="record_task"
                      value="0"
                  />
                </div>
              </div>

              <div
                  v-if="parseInt(recordInterval) && appropriateMood"
                  class="tasks_wrapper"
              >
                <p>Выберите время, когда удобно отметить результат выполнения задачи</p>

                <div class="select_wrapper">
                  <multiselect
                      :disabled="isFeedbackSaving"
                      :options="intervals"
                      v-model="moodForm.feedback_interval"
                      :allow-empty="false"
                      aria-label="Выберите интервал"
                      placeholder="Выберите интервал"
                      selectedLabel="Выбрано"
                      deselectLabel=""
                      selectLabel=""
                      name="feedback_intervals"
                  >
                    <template #noOptions>
                      Список загружается...
                    </template>
                  </multiselect>
                </div>
              </div>

              <div
                  class="save_button_wrapper"
                  v-if="recordInterval !== null && appropriateMood"
              >
                <button
                    class="btn btn-accent"
                    @click="updateOccurredTaskInterval"
                    :disabled="isFeedbackSaving"
                >
                  Сохранить
                </button>
              </div>

              <div
                  v-if="moodForm.task && moodForm.color_id && !appropriateMood"
                  class="assessed_mood_wrapper"
              >
                <p>
                  Ваше текущее эмоциональное состояние не способствует эффективному решению этой задачи
                </p>

                <p v-for="(item, key) in mismatchText" :key="key">
                  {{ item }}
                </p>

                <div class="recommendation_wrapper">
                  <div class="mood_recommendation">
                    <div>
                      <p>Если есть возможность, то рекомендуется сменить задачу на...</p>

                      <div class="select_wrapper">
                        <multiselect
                            :options="appropriateTasks"
                            v-model="taskReplace"
                            :allow-empty="false"
                            track-by="id"
                            label="text"
                            aria-label="Выберите задачу"
                            placeholder="Выберите задачу"
                            selectedLabel="Выбрано"
                            deselectLabel=""
                            selectLabel=""
                            name="filtered_tasks"
                        >
                          <template #noOptions>
                            Список загружается...
                          </template>
                        </multiselect>
                      </div>
                    </div>

                    <button class="btn btn-accent" @click="replaceTask">
                      Сменить задачу
                    </button>
                  </div>

                  <div class="mood_recommendation">
                    <p>
                      {{ mismatchRecommendation }}
                    </p>

                    <button class="btn btn-accent" @click="replaceEmotion">
                      Узнать как
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
                v-else-if="!recommendationsLoaded && moodForm.task && moodForm.color_id"
                class="mini-loader"
            >
              <mini-preloader />
            </div>
          </div>
        </div>
      </transition>

      <transition name="fade">
        <div class="question_wrapper" v-if="moodAssessorOpen" @click="resetAssessmentTool">
          <div
              class="question_content"
              @click.stop
              :class="moodAssessmentForm.current?.color ?? 'base'"
          >
            <button class="popup-close" @click="resetAssessmentTool">×</button>

            <div v-if="!lastSuggestedColor">
              <p v-if="moodAssessmentForm.index === 0">
                Чтобы точнее определить, в каком состоянии вы находитесь, выберите, какое из утверждений Вам сейчас ближе?
              </p>

              <p v-else>
                Тогда еще несколько утверждений. Выберите наиболее подходящее.
              </p>

              <div class="select_wrapper">
                <multiselect
                    :options="moodAssessmentQuestions"
                    v-model="moodAssessmentForm.current"
                    :allow-empty="false"
                    track-by="text"
                    label="text"
                    aria-label="Выберите утверждение"
                    placeholder="Выберите утверждение"
                    selectedLabel="Выбрано"
                    deselectLabel=""
                    selectLabel=""
                    name="mood_assessment"
                >
                  <template #noOptions>
                    Список загружается...
                  </template>
                </multiselect>
              </div>
            </div>

            <div v-else class="suggestion_wrapper">
              <p v-html="suggestionText"></p>

              <div v-if="!moodAssessed" class="button_wrapper">
                <button @click="setColor">
                  Верно
                </button>

                <button @click="reassessMood">
                  Не уверен
                </button>
              </div>

              <div v-else class="button_wrapper">
                <button @click="setColor">
                  Далее
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>

  <div v-else class="loader">
    <mini-preloader />
  </div>
</template>

<script>
import { computed, reactive } from '@vue/reactivity'
import { onBeforeMount, onBeforeUnmount, ref, watch } from '@vue/runtime-core'
import { useStore } from 'vuex'
import { notify } from '@kyvg/vue3-notification'
import Multiselect from 'vue-multiselect'

import MiniPreloader from '@/components/Technical/MiniPreloader.vue'
import CustomRadio from '@/components/Forms/Fields/CustomRadio.vue'
import StrategyModal from '@/views/MoodTracker/MoodTrackerStrategyModal.vue'
import textCard from './colorCardText'

export default {
  name: 'MoodTrackerForm',

  components: {
    StrategyModal,
    Multiselect,
    MiniPreloader,
    CustomRadio,
  },

  emits: ['submitted'],

  setup(props, context) {
    const store = useStore()

    const colorList = computed(() => store.state.tracker.colorList)
    const taskList = computed(() => store.state.tracker.taskList)
    const currentOccurredTask = computed(() => store.state.tracker.currentOccurredTask)

    const isLoading = ref(false)
    const activeColor = ref('')
    const activeBlock = ref(null)
    const taskOptions = ref([])
    const isTaskSet = ref(false)
    const recommendationsLoaded = ref(false)

    const appropriateMood = ref(null)
    const recommendedColor = ref('')
    const recommendedColorEntity = ref(null)
    const mismatchText = ref([])
    const mismatchRecommendation = ref('')
    const appropriateTasks = ref([])
    const taskReplace = ref(null)

    const selectedBlock = ref(null)
    const showColorChangeModal = ref(false)
    const taskOrEmotionWasChanged = ref(false)

    const recordInterval = ref(null)
    const isFeedbackSaving = ref(false)

    const moodAssessorOpen = ref(false)
    const suggestionText = ref(null)
    const moodAssessmentQuestions = ref([])
    const lastSuggestedColor = ref(null)
    const moodAssessed = ref(false)

    const moodForm = reactive({
      color_id: null,
      task_id: null,
      task: null,
      feedback_interval: null,
      schedule: {
        date: null,
        start_time: null,
        end_time: null,
        task_interval: null,
        repeat_type: null,
        comment: null,
      },
    })

    const colorsMap = {
      red: 'Красный',
      yellow: 'Жёлтый',
      blue: 'Синий',
      green: 'Зелёный',
    }

    const intervals = [
      '00:00-00:30', '00:30-01:00', '01:00-01:30', '01:30-02:00', '02:00-02:30', '02:30-03:00',
      '03:00-03:30', '03:30-04:00', '04:00-04:30', '04:30-05:00', '05:00-05:30', '05:30-06:00',
      '06:00-06:30', '06:30-07:00', '07:00-07:30', '07:30-08:00', '08:00-08:30', '08:30-09:00',
      '09:00-09:30', '09:30-10:00', '10:00-10:30', '10:30-11:00', '11:00-11:30', '11:30-12:00',
      '12:00-12:30', '12:30-13:00', '13:00-13:30', '13:30-14:00', '14:00-14:30', '14:30-15:00',
      '15:00-15:30', '15:30-16:00', '16:00-16:30', '16:30-17:00', '17:00-17:30', '17:30-18:00',
      '18:00-18:30', '18:30-19:00', '19:00-19:30', '19:30-20:00', '20:00-20:30', '20:30-21:00',
      '21:00-21:30', '21:30-22:00', '22:00-22:30', '22:30-23:00', '23:00-23:30', '23:30-24:00',
    ]

    const moodAssessmentForm = reactive({
      index: 0,
      red: 0,
      yellow: 0,
      blue: 0,
      green: 0,
      current: null,
    })

    const colorBlocks = ref([
      {
        id: 1,
        image: require('@/assets/images/mood_tracker/red.svg'),
        title: 'Высокая энергия / неприятные ощущения',
        color: '#9c0130',
        open: false,
        block: 'red',
        block_type_translate: 'в красном квадрате',
        text: null,
        detailed: textCard.red.detailed,
        current: '',
      },
      {
        id: 2,
        image: require('@/assets/images/mood_tracker/yellow.svg'),
        title: 'Высокая энергия / приятные ощущения',
        color: '#ff9e02',
        open: false,
        block: 'yellow',
        block_type_translate: 'в желтом квадрате',
        text: null,
        detailed: textCard.yellow.detailed,
        current: '',
      },
      {
        id: 3,
        image: require('@/assets/images/mood_tracker/blue.svg'),
        title: 'Низкая энергия / неприятные ощущения',
        color: '#100f76',
        open: false,
        block: 'blue',
        block_type_translate: 'в синем квадрате',
        text: null,
        detailed: textCard.blue.detailed,
        current: '',
      },
      {
        id: 4,
        image: require('@/assets/images/mood_tracker/green.svg'),
        title: 'Низкая энергия / приятные ощущения',
        color: '#3d9123',
        open: false,
        block: 'green',
        block_type_translate: 'в зеленом квадрате',
        text: null,
        detailed: textCard.green.detailed,
        current: '',
      },
    ])

    const padTimePart = (value) => String(value).padStart(2, '0')

    const formatDate = (date) => {
      const year = date.getFullYear()
      const month = padTimePart(date.getMonth() + 1)
      const day = padTimePart(date.getDate())

      return `${year}-${month}-${day}`
    }

    const formatTime = (date) => {
      const hours = padTimePart(date.getHours())
      const minutes = padTimePart(date.getMinutes())

      return `${hours}:${minutes}`
    }

    const getCurrentMomentSchedule = () => {
      const now = new Date()
      const end = new Date(now)

      end.setMinutes(end.getMinutes() + 30)

      const date = formatDate(now)
      const startTime = formatTime(now)
      const endTime = formatTime(end)

      return {
        date,
        start_time: startTime,
        end_time: endTime,
        task_interval: `${startTime}-${endTime}`,
      }
    }

    const fillCurrentMomentSchedule = () => {
      const currentSchedule = getCurrentMomentSchedule()

      moodForm.schedule.date = currentSchedule.date;
      moodForm.schedule.start_time = currentSchedule.start_time;
      moodForm.schedule.end_time = currentSchedule.end_time;
      moodForm.schedule.task_interval = currentSchedule.task_interval;
      moodForm.schedule.repeat_type = 'once';
      moodForm.schedule.comment = null;
    }

    const getRandomBlockText = (block) => {
      if (!block?.length) {
        return null;
      }

      const randomIndex = Math.floor(Math.random() * block.length);

      return block[randomIndex];
    }

    const getColorKeyByName = (name) => {
      return Object.keys(colorsMap).find((key) => colorsMap[key] === name)
    }

    const setActiveColorByName = (value) => {
      const currentColorKey = getColorKeyByName(value)

      activeColor.value = value
      activeBlock.value = colorBlocks.value.find((el) => el.block === currentColorKey) ?? null

      if (activeBlock.value) {
        activeBlock.value.current = getRandomBlockText(textCard[currentColorKey].resume)
      }
    }

    const closeAllCards = () => {
      colorBlocks.value.forEach((block) => {
        block.open = false
      })
    }

    const scrollToElement = (selector, offset = 90) => {
      setTimeout(() => {
        const container = document.querySelector('.page-container');
        const element = document.querySelector(selector);

        if (!container || !element) {
          return;
        }

        const containerRect = container.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();

        const top =
            container.scrollTop +
            elementRect.top -
            containerRect.top -
            offset;

        container.scrollTo({
          top: Math.max(top, 0),
          behavior: 'smooth',
        })
      }, 100)
    }

    const pickColor = (value) => {
      if (currentOccurredTask.value && moodForm.color_id) {
        notify({
          title: 'Нельзя изменить сделанный выбор напрямую',
          text: 'Чтобы изменить состояние, используйте рекомендацию “Узнать как”.',
          type: 'info',
        })

        return
      }

      const color = colorList.value.find((el) => el.name === value)

      if (!color) {
        notify({
          title: 'Цвет не найден',
          type: 'warning',
        })

        return
      }

      moodForm.color_id = color.id

      fillCurrentMomentSchedule()
      setActiveColorByName(value)
      closePopup()
      closeAllCards()
      scrollToElement('.task_content')
    }

    const getRecommendation = () => {
      if (!moodForm.task || !moodForm.color_id || !activeBlock.value) {
        return
      }

      const taskColor = taskList.value.find((el) => el.id === parseInt(moodForm.task.id))

      if (!taskColor) {
        return
      }

      recommendedColorEntity.value = colorList.value.find((el) => el.id === parseInt(taskColor.color_id))

      if (!recommendedColorEntity.value) {
        return
      }

      const recommendedColorKey = getColorKeyByName(recommendedColorEntity.value.name)

      appropriateMood.value = parseInt(moodForm.color_id) === parseInt(taskColor.color_id)
      recommendedColor.value = recommendedColorEntity.value.name

      mismatchText.value = textCard[activeBlock.value.block]?.mismatch?.[recommendedColorKey] ?? []
      mismatchRecommendation.value = textCard[recommendedColorKey]?.mismatch_recommendation ?? ''

      appropriateTasks.value = taskList.value
          .filter((task) => parseInt(task.color_id) === parseInt(moodForm.color_id))
          .map((el) => ({
            id: el.id,
            text: el.task,
          }))
    }

    const setOccurredTask = async () => {
      fillCurrentMomentSchedule()

      const load = {
        planned_task_id: null,
        task_id: moodForm.task.id,
        color_id: moodForm.color_id,
        task_date: moodForm.schedule.date,
        task_interval: moodForm.schedule.task_interval,
        repeat_type: 'once',
        comment: null,
      }

      await store.dispatch('tracker/setOccurredTask', load)

      context.emit('submitted')
    }

    const updateOccurredTaskInterval = async () => {
      if (!currentOccurredTask.value) {
        notify({
          title: 'Запись задачи ещё не создана',
          type: 'warning',
        });

        return;
      }

      if (parseInt(recordInterval.value) && !moodForm.feedback_interval) {
        notify({
          title: 'Укажите интервал',
          text: 'Выберите интервал для записи',
          type: 'warning',
        });

        return
      }

      const feedbackInterval = parseInt(recordInterval.value)
          ? moodForm.feedback_interval
          : null

      isFeedbackSaving.value = true

      try {
        await store.dispatch('tracker/updateOccurredTaskInterval', {
          id: currentOccurredTask.value,
          feedback_interval: feedbackInterval,
        });

        notify({
          title: 'Интервал сохранён',
          type: 'info',
        })

        context.emit('submitted');
        closeTaskPopup();
      } finally {
        isFeedbackSaving.value = false;
      }
    }

    const replaceEmotionOrTask = async (type, id) => {
      if (!currentOccurredTask.value) {
        notify({
          title: 'Запись задачи ещё не создана',
          type: 'warning',
        });

        return
      }

      taskOrEmotionWasChanged.value = true

      await store.dispatch('tracker/changeEmotionOrTask', {
        id: currentOccurredTask.value,
        type,
        replacement_id: id,
      })

      getRecommendation();
      context.emit('submitted');
    }

    const replaceTask = async () => {
      if (!taskReplace.value) {
        notify({
          title: 'Выберите задачу',
          type: 'info',
        });

        return
      }

      moodForm.task = taskReplace.value;

      await replaceEmotionOrTask('task', taskReplace.value.id);
    }

    const replaceEmotion = async () => {
      if (!recommendedColorEntity.value) {
        return;
      }

      await replaceEmotionOrTask('color', recommendedColorEntity.value.id)

      showColorChangeModal.value = true;
    }

    const handleColorChange = () => {
      if (!recommendedColorEntity.value) {
        return;
      }

      moodForm.color_id = recommendedColorEntity.value.id;

      setActiveColorByName(recommendedColorEntity.value.name);

      showColorChangeModal.value = false;

      getRecommendation();
    }

    const reset = () => {
      moodForm.color_id = null;
      moodForm.task_id = null;
      moodForm.task = null;
      moodForm.feedback_interval = null;
      moodForm.schedule.date = null;
      moodForm.schedule.start_time = null;
      moodForm.schedule.end_time = null;
      moodForm.schedule.task_interval = null;
      moodForm.schedule.repeat_type = 'once';
      moodForm.schedule.comment = null;

      activeColor.value = '';
      activeBlock.value = null;
      appropriateMood.value = null;
      recommendedColor.value = '';
      recommendedColorEntity.value = null;
      mismatchText.value = [];
      mismatchRecommendation.value = '';
      appropriateTasks.value = [];
      taskReplace.value = null;
      isTaskSet.value = false;
      recommendationsLoaded.value = false;
      taskOrEmotionWasChanged.value = false;
      showColorChangeModal.value = false;
      recordInterval.value = null;
      isFeedbackSaving.value = false;

      store.commit('tracker/clearCurrentOccurredTask');
    }

    const closeTaskPopup = () => {
      reset();
    }

    const toggleCard = (index) => {
      const item = colorBlocks.value[index];

      item.open = !item.open;

      colorBlocks.value.forEach((block) => {
        if (block !== item) {
          block.open = false
        }
      })

      item.text = getRandomBlockText(textCard[item.block].description);
    }

    const openPopup = (block) => {
      selectedBlock.value = block;

      scrollToElement('.popup-content');
    }

    const closePopup = () => {
      selectedBlock.value = null;
    }

    const shiftAssessmentQuestions = () => {
      const tempArray = []

      Object.keys(colorsMap).forEach((key) => {
        tempArray.push({
          color: key,
          text: textCard[key].assessment[moodAssessmentForm.index],
        })
      })

      moodAssessmentQuestions.value = tempArray
    }

    const checkMood = () => {
      const currentColor = moodAssessmentForm.current.color

      moodAssessmentForm[currentColor]++

      let text = 'Скорее всего, '
      const colorBlock = colorBlocks.value.find((el) => el.block === currentColor)

      if (moodAssessmentForm[currentColor] === 2) {
        text += `<span style="color: #51bb50">вы все же в ${colorBlock.block_type_translate}</span>. У вас ${colorBlock.title.replace(' /', ',').toLowerCase()}.`
        moodAssessed.value = true
      } else {
        text += `вы в ${colorBlock.block_type_translate}. У вас ${colorBlock.title.replace(' /', ',').toLowerCase()}. Верно?`
      }

      lastSuggestedColor.value = currentColor
      suggestionText.value = text
    }

    const openAssessmentTool = () => {
      closePopup()
      shiftAssessmentQuestions()
      moodAssessorOpen.value = true

      scrollToElement('.question_content')
    }

    const resetAssessmentTool = () => {
      moodAssessorOpen.value = false
      moodAssessmentForm.index = 0
      moodAssessmentForm.red = 0
      moodAssessmentForm.yellow = 0
      moodAssessmentForm.blue = 0
      moodAssessmentForm.green = 0
      moodAssessmentForm.current = null
      moodAssessed.value = false
      suggestionText.value = null
      lastSuggestedColor.value = null
    }

    const reassessMood = () => {
      moodAssessmentForm.index++
      shiftAssessmentQuestions()
      lastSuggestedColor.value = null
      suggestionText.value = null
      moodAssessmentForm.current = null
    }

    const setColor = () => {
      const selectedColor = moodAssessmentForm.current?.color

      if (!selectedColor) {
        return
      }

      const colorName = colorsMap[selectedColor]

      moodAssessorOpen.value = false
      resetAssessmentTool()
      pickColor(colorName)
    }

    onBeforeMount(async () => {
      isLoading.value = true

      await store.dispatch('tracker/getTasks')

      taskOptions.value = taskList.value.map((el) => ({
        id: el.id,
        text: el.task,
      }))

      await store.dispatch('tracker/getColors')

      isLoading.value = false
    })

    onBeforeUnmount(() => {
      store.commit('tracker/clearCurrentOccurredTask')
    })

    watch(
        () => [moodForm.color_id, moodForm.task],
        async () => {
          recordInterval.value = null
          moodForm.feedback_interval = null
          taskReplace.value = null
          recommendationsLoaded.value = false

          if (!moodForm.color_id || !moodForm.task) {
            return
          }

          isTaskSet.value = true

          if (!taskOrEmotionWasChanged.value && !currentOccurredTask.value) {
            await setOccurredTask()
          }

          getRecommendation()
          recommendationsLoaded.value = true
        }
    )

    watch(
        () => moodAssessmentForm.current,
        () => {
          if (moodAssessmentForm.current) {
            checkMood()
          }
        }
    )

    return {
      moodForm,
      taskOptions,
      colorList,
      colorsMap,
      activeColor,
      activeBlock,
      pickColor,
      isLoading,
      appropriateMood,
      colorBlocks,
      toggleCard,
      getRandomBlockText,
      selectedBlock,
      openPopup,
      closePopup,
      mismatchText,
      mismatchRecommendation,
      appropriateTasks,
      taskReplace,
      moodAssessorOpen,
      moodAssessmentForm,
      moodAssessmentQuestions,
      shiftAssessmentQuestions,
      openAssessmentTool,
      resetAssessmentTool,
      suggestionText,
      lastSuggestedColor,
      moodAssessed,
      reassessMood,
      setColor,
      isTaskSet,
      recommendationsLoaded,
      replaceTask,
      replaceEmotion,
      handleColorChange,
      showColorChangeModal,
      currentOccurredTask,
      recommendedColorEntity,
      closeTaskPopup,
      intervals,
      recordInterval,
      isFeedbackSaving,
      updateOccurredTaskInterval,
    }
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped lang="scss">
.tracker_wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 25px;
  padding: 50px 20px;

  p {
    font-size: 16px;
  }
}

.mood_color_block {
  width: 60px;
  height: 80px;
  cursor: pointer;
  position: relative;
}

.mood_color_block:hover {
  opacity: 0.9;
}

.color_list {
  margin: 20px 0;
  display: flex;
  width: 100%;
  column-gap: 25px;
  justify-content: right;
}

.question_wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 15px;
}

.question {
  font-size: 18px;
}

.answers {
  display: flex;
  column-gap: 25px;
}

.tasks_wrapper .form-group {
  justify-content: flex-start;
}

.loader {
  padding: 120px 0;
  text-align: center;
}

.mood_color_block.yellow {
  background-image: linear-gradient(rgba(255, 236, 138, 0.6), rgba(255, 236, 138, 0.6)), url("../../assets/images/yellow-card.png");
  background-size: cover;
  background-position: center;
  border: 3px solid #ffec8a;
}

.mood_color_block.green {
  background-image: linear-gradient(rgba(176, 220, 156, 0.6), rgba(176, 220, 156, 0.6)), url("../../assets/images/green-card.png");
  background-size: cover;
  background-position: center;
  border: 3px solid #b0dc9c;
}

.mood_color_block.blue {
  background-image: linear-gradient(rgba(130, 152, 204, 0.6), rgba(130, 152, 204, 0.6)), url("../../assets/images/blue-card.png");
  background-size: cover;
  background-position: center;
  border: 3px solid #8298cc;
}

.mood_color_block.red {
  background-image: linear-gradient(rgba(242, 145, 117, 0.6), rgba(242, 145, 117, 0.6)), url("../../assets/images/red-card.png");
  background-size: cover;
  background-position: center;
  border: 3px solid #f29175;
}

.color_text {
  font-weight: bold;
}

.text_yellow {
  color: #ffec8a;
}

.text_green {
  color: #b0dc9c;
}

.text_blue {
  color: #8298cc;
}

.text_red {
  color: #f29175;
}

.active::after {
  content: "✓";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 80px;
  color: #00e287;
  pointer-events: none;
}

.red.active {
  background-image: url("../../assets/images/mood_tracker/red.svg");
}

.green.active {
  background-image: url("../../assets/images/mood_tracker/green.svg");
}

.blue.active {
  background-image: url("../../assets/images/mood_tracker/blue.svg");
}

.yellow.active {
  background-image: url("../../assets/images/mood_tracker/yellow.svg");
}

.repeat_button_wrapper {
  display: flex;
  column-gap: 10px;
  margin-left: auto;
}

.recommendation_wrapper {
  margin-top: 15px;
  font-size: 18px;
  text-align: justify;
}

.square_recommendation_wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}

@media (max-width: 400px) {
  .color_list {
    flex-direction: column;
    row-gap: 10px;
  }

  .mood_color_block {
    width: 100%;
  }
}

.cards-container {
  position: relative;
  width: 100%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 5px;
  row-gap: 5px;
  padding: 40px 40px;
  justify-items: center;
  border: 1px solid #ccc;
  background: #eef1f8;
}

.card {
  padding: 0;
  width: 450px;
  height: 600px;
  position: relative;
  box-shadow: 9px 10px 22px -8px rgba(209, 193, 209, .5);
}

.card-front,
.card-back {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.card-front {
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 20px;
  padding: 10px;
  text-transform: uppercase;
  font-weight: bold;
  color: white;
  opacity: 1;
  cursor: pointer;
}

.card-back {
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px;
  text-align: center;
  border: 1px solid #ccc;
  opacity: 0;
  color: #fff;
}

.card.open .card-front {
  opacity: 0;
}

.card.open .card-back {
  opacity: 1;
}

.card {
  transition: transform 0.2s ease;
}

.card.open {
  transform: rotateY(180deg);
}

.card-back {
  position: relative;
  transform: rotateY(180deg);
}

.card-front:hover {
  transform: scale(1.02);
}

.close-btn {
  position: absolute;
  top: 10px;
  left: 10px;
  background: transparent;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #000;
  z-index: 2;
}

.close-btn:hover {
  color: #000;
}

.card-back-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 10px;
  width: 100%;
  margin-top: 20px;
}

.card-back-status {
  padding: 5px;
  border: 1px solid #fff;
  color: #ffffff;
}

.card-back-detailed {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-top: auto;
}

.card-back-detailed button {
  border: 1px solid #fff;
  padding: 25px;
  color: #fff;
}

.card-back-status:hover,
.card-back-detailed button:hover {
  opacity: 0.8;
}

.card-back-text {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  align-items: flex-start;
}

.popup-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
}

.popup-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  row-gap: 40px;
  padding: 20px;
  max-width: 800px;
  min-height: 800px;
  width: 90%;
  position: relative;
  color: #fff;
  border: 5px solid #cccccc;
}

.popup-content ul {
  display: flex;
  flex-direction: column;
  row-gap: 25px;
}

.popup-close {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  z-index: 2;
}

.popup_additional_wrapper {
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 25px;
}

.popup_additional_wrapper p {
  font-size: 22px;
  color: #ffffff;
  font-weight: bold;
}

.popup_button_wrapper,
.button_wrapper {
  display: flex;
  column-gap: 25px;
}

.popup_button_wrapper button,
.button_wrapper button {
  padding: 10px 20px;
  background-color: #edf2f8;
}

.popup_button_wrapper button:hover,
.button_wrapper button:hover {
  opacity: 0.8;
}

.task_wrapper {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  z-index: 4;
}

.task_content {
  width: 80%;
  padding: 40px 0;
  position: relative;
  background-color: #ffffff;
  border: 4px solid;
}

.resume_block {
  margin: 0 20px 30px;
  padding: 50px 0;
  position: relative;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}

.additional_block_wrapper {
  width: 100%;
  position: absolute;
  display: flex;
  justify-content: space-between;
}

.additional_block_wrapper:first-child {
  top: 0;
}

.additional_block_wrapper {
  bottom: 0;
}

.colorful_block {
  width: 30px;
  height: 30px;
}

.yellow {
  background-color: #ff9e02;
}

.blue {
  background-color: #100f76;
}

.green {
  background-color: #3d9123;
}

.red {
  background-color: #9c0130;
}

.tasks_wrapper {
  padding: 30px 20px;
  background-color: #edf2f8;
}

.header_green {
  font-size: 18px;
  font-weight: bold;
  color: #51bb50;
}

.select_wrapper {
  margin: 20px 0;
  width: 80%;
}

.assessed_mood_wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  padding: 20px;
}

.save_button_wrapper {
  display: flex;
  justify-content: end;
  padding: 10px 20px;
}

.recommendation_wrapper {
  display: flex;
  column-gap: 15px;
  justify-content: space-between;
  align-items: stretch;
}

.mood_recommendation {
  display: flex;
  flex-direction: column;
  padding: 20px;
  row-gap: 20px;
  width: 48%;
  min-height: 350px;
  font-size: 16px;
  background-color: #edf2f8;
}

.mood_recommendation button {
  margin-top: auto;
}

.mood_recommendation .select_wrapper {
  width: 100%;
}

.question_wrapper {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  z-index: 5;
}

.question_content {
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  width: 80%;
  padding: 40px 20px;
  position: relative;
  background-color: #ffffff;
  border: 2px solid #000;
}

.suggestion_wrapper p {
  font-size: 18px;
  font-weight: bold;
}

.suggestion_wrapper .button_wrapper {
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
  column-gap: 20px;
}

.mini-loader {
  text-align: center;
  padding: 40px 0;
}

:deep(.multiselect__option) {
  padding: 10px 5px;
  white-space: normal;
}

:deep(.multiselect--disabled .multiselect__select) {
  background-color: #ffffff;
}

@media (max-width: 700px) {
  .recommendation_wrapper {
    flex-direction: column;
    row-gap: 20px;
  }

  .mood_recommendation {
    width: 100%;
  }
}

@media (max-width: 1480px) {
  .card {
    width: 350px;
    height: 500px;
  }
}

@media (max-width: $tablet-breakpoint) {
  .card {
    width: 400px;
    height: 600px;
    font-size: 12px;
  }
}

@media (max-width: $tablet-breakpoint) {
  .cards-container {
    padding: 10px;
    grid-template-columns: 1fr;
  }

  .task_content {
    width: 100%;
  }

  .mood_recommendation {
    width: 100%;
  }
}

@media (max-width: 550px) {
  .card {
    width: 260px;
    height: 480px;
    font-size: 12px;
  }

  .popup_button_wrapper {
    row-gap: 20px;
    flex-wrap: wrap;
  }

  .select_wrapper {
    width: 100%;
  }
}

.question_content.base {
  background-color: #ffffff;
}

.question_content.yellow {
  color: #ffffff;
  background-color: #ff9e02;
}

.question_content.blue {
  color: #ffffff;
  background-color: #100f76;
}

.question_content.green {
  color: #ffffff;
  background-color: #3d9123;
}

.question_content.red {
  color: #ffffff;
  background-color: #9c0130;
}

.question_content span.special_green {
  color: #51bb50;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.popup_button_wrapper button,
:deep(.button_wrapper button) {
  color: var(--main-font);
}
</style>